export class AssignShipmentToTPL {
    TPLId: number;
    TPLNumber: string;
    TPLPrice?: number;
    TPLCreatedWhen: any;
    ShipmentId: number;
    ShipmentNumber: string;
    IsTPLTransit?: boolean;
}